import type { CreateTicketBody, TicketKind, TopicDTO } from "@zplanem/responses"

export interface TicketBoardFilters {
	projectId?: string
	assigneeId?: string
	topicId?: string
	kind?: TicketKind
}

export function hasTicketBoardFilters(
	filters: TicketBoardFilters,
	lockedProjectId?: string,
): boolean {
	return Boolean(
		(filters.projectId && filters.projectId !== lockedProjectId) ||
			filters.assigneeId ||
			filters.topicId ||
			filters.kind,
	)
}

export function clearedTicketBoardFilters(
	lockedProjectId?: string,
): TicketBoardFilters {
	return lockedProjectId ? { projectId: lockedProjectId } : {}
}

export function quickCreateTicketBody(
	title: string,
	filters: TicketBoardFilters,
): CreateTicketBody {
	return {
		title,
		kind: filters.kind ?? "task",
		...(filters.projectId ? { projectId: filters.projectId } : {}),
		...(filters.assigneeId ? { assigneeUserId: filters.assigneeId } : {}),
		...(filters.topicId ? { topicId: filters.topicId } : {}),
	}
}

export function clearMissingTicketFilters(
	filters: TicketBoardFilters,
	options: {
		projectIds: ReadonlySet<string>
		assigneeIds: ReadonlySet<string>
		topicIds: ReadonlySet<string>
	},
): TicketBoardFilters {
	return {
		...(filters.projectId && options.projectIds.has(filters.projectId)
			? { projectId: filters.projectId }
			: {}),
		...(filters.assigneeId && options.assigneeIds.has(filters.assigneeId)
			? { assigneeId: filters.assigneeId }
			: {}),
		...(filters.topicId && options.topicIds.has(filters.topicId)
			? { topicId: filters.topicId }
			: {}),
		...(filters.kind ? { kind: filters.kind } : {}),
	}
}

export function topicLabelForTicket(
	ticket: { topicId: string | null },
	topics: readonly TopicDTO[],
): string | null {
	if (!ticket.topicId) return null
	return topics.find((topic) => topic.id === ticket.topicId)?.name ?? null
}

export function topicsVisibleForTicketScope(
	topics: readonly TopicDTO[],
	projectId: string | null | undefined,
): TopicDTO[] {
	return topics.filter(
		(topic) => topic.projectId === null || topic.projectId === projectId,
	)
}
